<p-dialog
  [(visible)]="visible"
  header="Add to Watchlist"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '600px', maxWidth: '90vw' }"
>
  <div class="space-y-4">
    <!-- Ticker Display -->
    <div class="p-3 bg-yellow-50 dark:bg-yellow-600/20 rounded border border-yellow-200 dark:border-yellow-500">
      <div class="flex items-center gap-2">
        <span class="text-sm text-black dark:text-white">Adding ticker:</span>
        <span class="text-xl font-bold text-gray-900 dark:text-white">{{ ticker() }}</span>
      </div>
    </div>

    <!-- Watchlist Select -->
    @if (watchlists().length > 0) {
      <div class="form-field">
        <label for="watchlist-select" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Select Watchlist <span class="text-red-500">*</span>
        </label>
        <p-select
          id="watchlist-select"
          [options]="watchlists()"
          [(ngModel)]="selectedWatchlist"
          (onChange)="onWatchlistChange($event)"
          optionLabel="name"
          placeholder="Choose a watchlist"
          [showClear]="true"
          class="w-full"
          [disabled]="isLoading()"
          [scrollHeight]="'200px'"
          appendTo="body"
        >
          <ng-template pTemplate="selecteditem" let-watchlist>
            @if (watchlist) {
              <div class="font-semibold">{{ watchlist.name }}</div>
            }
          </ng-template>
          <ng-template pTemplate="item" let-watchlist>
            <div class="font-semibold">{{ watchlist.name }}</div>
          </ng-template>
        </p-select>
      </div>
    } @else {
      <div class="form-field">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Watchlists
        </label>
        <div class="p-4 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-center">
          <p class="text-sm text-gray-600 dark:text-gray-400 mb-2">
            No watchlists found
          </p>
          <p class="text-xs text-gray-500 dark:text-gray-500">
            Create a watchlist first to add tickers
          </p>
        </div>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-between w-full">
      <p-button
        label="Create New Watchlist"
        icon="pi pi-bookmark"
        (onClick)="openCreateDialog()"
        [outlined]="true"
        [disabled]="isLoading()"
      ></p-button>
      <div class="flex gap-2">
        <p-button
          label="Cancel"
          (onClick)="hide()"
          severity="secondary"
          [outlined]="true"
          [disabled]="isLoading()"
        ></p-button>
        <p-button
          label="Add to Watchlist"
          icon="pi pi-plus"
          (onClick)="addTicker()"
          [loading]="isLoading()"
          [disabled]="!isFormValid()"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- Create Watchlist Dialog -->
<app-watchlist-create-dialog
  (watchlistCreated)="onWatchlistCreated($event)"
></app-watchlist-create-dialog>
